import { PaymentStatus } from "@redotech/redo-billing-common/service-invoice";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const rebillServiceInvoice = {
  name: "rebillServiceInvoice" as const,
  input: z.object({ invoiceId: zExt.objectId() }),
  output: z.object({ paymentStatus: createEnum(PaymentStatus) }),
};
